// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TypesClusterMemberStatus } from './TypesClusterMemberStatus';
import {
  TypesClusterMemberStatusFromJSON,
  TypesClusterMemberStatusFromJSONTyped,
  TypesClusterMemberStatusToJSON,
  TypesClusterMemberStatusToJSONTyped,
} from './TypesClusterMemberStatus';

/**
 *
 * @export
 * @interface TypesClusterStatus
 */
export interface TypesClusterStatus {
  /**
   *
   * @type {{ [key: string]: TypesClusterMemberStatus; }}
   * @memberof TypesClusterStatus
   */
  clusterMembers?: { [key: string]: TypesClusterMemberStatus };
  /**
   *
   * @type {number}
   * @memberof TypesClusterStatus
   */
  membersRunningLatestVersion?: number;
  /**
   *
   * @type {number}
   * @memberof TypesClusterStatus
   */
  membersWithBoltAvailable?: number;
  /**
   *
   * @type {number}
   * @memberof TypesClusterStatus
   */
  runningMembers?: number;
  /**
   *
   * @type {number}
   * @memberof TypesClusterStatus
   */
  votingMembers?: number;
}

/**
 * Check if a given object implements the TypesClusterStatus interface.
 */
export function instanceOfTypesClusterStatus(
  value: object,
): value is TypesClusterStatus {
  return true;
}

export function TypesClusterStatusFromJSON(json: any): TypesClusterStatus {
  return TypesClusterStatusFromJSONTyped(json, false);
}

export function TypesClusterStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TypesClusterStatus {
  if (json == null) {
    return json;
  }
  return {
    clusterMembers:
      json['ClusterMembers'] == null
        ? undefined
        : mapValues(json['ClusterMembers'], TypesClusterMemberStatusFromJSON),
    membersRunningLatestVersion:
      json['MembersRunningLatestVersion'] == null
        ? undefined
        : json['MembersRunningLatestVersion'],
    membersWithBoltAvailable:
      json['MembersWithBoltAvailable'] == null
        ? undefined
        : json['MembersWithBoltAvailable'],
    runningMembers:
      json['RunningMembers'] == null ? undefined : json['RunningMembers'],
    votingMembers:
      json['VotingMembers'] == null ? undefined : json['VotingMembers'],
  };
}

export function TypesClusterStatusToJSON(json: any): TypesClusterStatus {
  return TypesClusterStatusToJSONTyped(json, false);
}

export function TypesClusterStatusToJSONTyped(
  value?: TypesClusterStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ClusterMembers:
      value['clusterMembers'] == null
        ? undefined
        : mapValues(value['clusterMembers'], TypesClusterMemberStatusToJSON),
    MembersRunningLatestVersion: value['membersRunningLatestVersion'],
    MembersWithBoltAvailable: value['membersWithBoltAvailable'],
    RunningMembers: value['runningMembers'],
    VotingMembers: value['votingMembers'],
  };
}
